module.exports = __webpack_public_path__ + "static/media/mexican-categories.eac15d45.jpg";